import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createNewVehiculeCheckTypeCheckPoint,
  deleteVehiculeCheckTypeCheckPoint,
  updateVehiculeCheckTypeCheckPoint,
} from '@/api/vehicule-check-type-check-point/vehicule-check-type-check-point';
import { ErrorResponse } from '@/utils/axios.http';
import { TCustomQueryProps } from '@/type/hooks.types';
import { TVehiculeCheckTypeCheckPointSchema } from '@/schemas/vehicule-check-type-check-point/vehicule-check-type-check-point.schema';

export const useCreateNewVehiculeCheckTypeCheckPoint = ({
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: TVehiculeCheckTypeCheckPointSchema) =>
      createNewVehiculeCheckTypeCheckPoint(data),
    onSuccess: (_, variables) => {
      const { vehiculeCheckTypeId } = variables;

      queryClient.invalidateQueries({
        queryKey: ['getVehiculeCheckTypeById', vehiculeCheckTypeId],
      });

      handleSuccess?.();
    },
    onError: (error: ErrorResponse) => {
      console.error(error.error);
    },
  });
};

export const useUpdateVehiculeCheckTypeCheckPoint = ({
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TVehiculeCheckTypeCheckPointSchema) =>
      updateVehiculeCheckTypeCheckPoint(data),
    onSuccess: (_, variables) => {
      const { vehiculeCheckTypeId } = variables;

      queryClient.invalidateQueries({
        queryKey: ['getVehiculeCheckTypeById', vehiculeCheckTypeId],
      });

      handleSuccess?.();
    },
    onError: (error: ErrorResponse) => {
      console.error(
        'Error when updating vehicule check type checkpoint:',
        error,
      );
    },
  });
};

export const useDeleteVehiculeCheckTypeCheckPoint = ({
  handleSuccess,
}: Partial<TCustomQueryProps> = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: TVehiculeCheckTypeCheckPointSchema) =>
      deleteVehiculeCheckTypeCheckPoint(data),
    onSuccess: (_, variables) => {
      const { vehiculeCheckTypeId } = variables;

      queryClient.invalidateQueries({
        queryKey: ['getVehiculeCheckTypeById', vehiculeCheckTypeId],
      });

      handleSuccess?.();
    },
    onError: (error: ErrorResponse) => {
      console.error(error.error);
    },
  });
};
